window.AppBase.module('State', function (Module, App) {
  'use strict'

  var currentView = null

  App.reqres.setHandler('state:get_current_view', function () {
    return currentView
  })

  App.commands.setHandler('state:set_current_view', function (view) {
    currentView = view
  })
})
